import { Container } from './Container';
import { IContainer } from './IContainer';

export class CoreContainer extends Container implements IContainer {}
